import React from 'react';
// @ts-ignore
import { GoogleApiWrapper, Map, Marker, Polyline, Polygon } from 'google-maps-react';
import gql from 'graphql-tag';
import { useQuery } from "@apollo/react-hooks";
// @ts-ignore
import keyBy from 'lodash/keyBy';

const INITIAL_CENTER = { lat: 38.201724, lng: -92.710139 };

const GET_MAP_DATA = gql`
  query mapData {
    nodes {
      id
      coordinates {
        lat: latitude
        lng: longitude
      }
    }
    edges {
      id
      nodeOne
      nodeTwo
    }
    config {
     serviceArea {
      lat: latitude
      lng: longitude
     }
    }
  }
`;

function MapContainer({ google, selectedNode, setSelectedNode, selectedEdge, setSelectedEdge }: any) {
  const { loading, data } = useQuery(GET_MAP_DATA);

  const keyedNodes = React.useMemo(() => keyBy(data?.nodes, (n:any) => n.id), [data]);

  const matchCoordinates = (node: any) => {
    return keyedNodes[node].coordinates
  };

  if (loading) {
    return 'loading...'
  }

  return (
    <Map
      google={google}
      initialCenter={INITIAL_CENTER}
      style={{ height: '700px', position: 'relative' }}
      containerStyle={{ position: 'relative' }}
    >
      {data?.nodes.map(({ id, name, coordinates }: any) =>
        <Marker
          // @ts-ignore
          title={id}
          name={name}
          key={id}
          position={coordinates}
          onClick={() => setSelectedNode(id)}
          icon={{
            url: id === selectedNode ? `${process.env.PUBLIC_URL}/dot_green.png` : `${process.env.PUBLIC_URL}/dot.png`,
            anchor: new google.maps.Point(8,8),
            scaledSize: new google.maps.Size(16,16)
          }}
        />
      )}
      {data?.edges.map((e:any) => (
        <Polyline
          key={e.id === selectedEdge ? `${e.id}-selected` : e.id}
          path={[matchCoordinates(e.nodeOne), matchCoordinates(e.nodeTwo)]}
          strokeColor={e.id === selectedEdge ? "#149414" : "#000000"}
          onClick={() => setSelectedEdge(e.id)}
          strokeWeight={2}
        />
      ))}
      {data?.config?.serviceArea?.length > 0 &&
        <Polygon
          paths={data.config.serviceArea}
          strokeColor="#FF0000"
          strokeOpacity={0.5}
          strokeWeight={2}
          fillColor="#0000FF"
          fillOpacity={0}
        />
      }
    </Map>
  );
}

// @ts-ignore
export default GoogleApiWrapper({ apiKey: process.env.REACT_APP_MAPS_API_KEY })(MapContainer);
